import { render, staticRenderFns } from "./MainViews.vue?vue&type=template&id=f0ef131e"
import script from "./MainViews.vue?vue&type=script&lang=js"
export * from "./MainViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports